// native
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

// service
import { PatientsService } from 'app/core/services/patients.service';
import { TestsService } from 'app/core/services/tests.service';

// models
import { Patient, Test } from 'app/models';

@Component({
    selector: 'app-view-test',
    templateUrl: './view-test.component.html',
    standalone: false
})
export class ViewTestComponent implements OnInit {

  test: Test;
  patient: Patient;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private testsService: TestsService,
    private patientsService: PatientsService
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      const id = params['id'];

      this.testsService.getOne(id).subscribe((test: Test) => {
        this.test = test;
        this.patientsService.getOne(test.patient.id).subscribe((patient: Patient) => {
          this.patient = patient;
        }, err => {
          this.router.navigate(['/tests']);
        });
      }, err => {
        this.router.navigate(['/tests']);
      });
    });
  }
}
